import React from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-date-picker";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

import Edit from "./icons/Edit";

const Input = ({
  type,
  placeholder,
  value,
  showEditIcon = false,
  className = `${showEditIcon ? "pr-[30px]" : ""}`,
  onChange,
  labelName,
  labelClassName = "block text-[13px] leading-[20px]",
  inputBox = "",
  inputMain = "pb-[20px] relative",
  isError = false,
  errorMessage = "",
  disabled = false,
  disabledDate,
  dateFormat,
  disabledClass,
  onBlur,
  onFocus,
  onEditClick,
  padding,
  ...rest
}) => {
  return (
    <div className={`${!isError ? "" : inputMain}`}>
      <div
        className={`${inputBox} py-[5px] px-[10px] xl:px-[16px] rounded-[6px] border transition-all duration-500 cursor-pointer relative ${
          disabled
            ? disabledClass
              ? disabledClass
              : "bg-gray-100 border-gray-300 text-gray-400 disabled:cursor-not-allowed"
            : isError
            ? "border-orange-500 bg-orange-50"
            : "border-primary-50 bg-primary-50 focus-within:border-primary-500"
        }`}
      >
        <label
          className={`${className} w-full bg-transparent outline-none placeholder-gray-400 ${
            disabled
              ? disabledClass
                ? "text-primary-400"
                : "text-gray-400 cursor-not-allowed"
              : isError
              ? "text-orange-800"
              : "text-primary-400"
          }`}
        >
          {labelName}
        </label>
        {type === "date" ? (
          // <DatePicker
          //   selected={value}
          //   onChange={onChange}
          //   onBlur={onBlur}
          //   onFocus={onFocus}
          //   disabled={disabled}
          //   placeholderText={placeholder}
          //   className={`w-full bg-transparent outline-none ${className} ${showEditIcon ? "pr-[25px]" : ""}`}
          //   dateFormat={dateFormat}
          //   showMonthDropdown
          //   showYearDropdown
          //   dropdownMode="select" 
          //   {...rest}
          // />
          <DatePicker
          onChange={onChange}
          value={value}
          onBlur={onBlur}
          onFocus={onFocus}
          disabled={disabled}
          format={dateFormat}
          maxDate={new Date()}
          calendarIcon={null}
          clearIcon={value ? undefined : null}
          dayPlaceholder="DD"
          monthPlaceholder="MM"
          yearPlaceholder="YYYY"  
          className={`w-full bg-transparent border-none outline-none ${className} ${showEditIcon ? "pr-[25px]" : ""}`}
          {...rest}

      />
        ) : type === "textarea" ? (
          <textarea
            onFocus={onFocus}
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e)}
            className={`${className} ${showEditIcon ? "pr-[25px]" : ""} resize-none min-h-[60px]`}
            disabled={disabled}
            onBlur={onBlur}
            {...rest}
          />
        ) : (
          <input
            onFocus={onFocus}
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e)}
            className={`${className} ${showEditIcon ? "pr-[25px]" : ""}`}
            disabled={disabled}
            onBlur={onBlur}
            {...rest}
          />
        )}
        {showEditIcon && (
          <span
            className="w-[20px] h-[20px] absolute right-2.5 top-1/2 -translate-y-1/2 flex items-center justify-center cursor-pointer text-primary-500 hover:text-primary-700 transition-colors"
            onClick={onEditClick}
          >
            <Edit fill="currentColor" height={16} width={16} />
          </span>
        )}
      </div>
      <div className="absolute left-0 bottom-0 text-orange-800 text-[11px] uppercase mt-1 font-medium">
        {isError ? errorMessage || "" : ""}
      </div>
      {/*error bg-orange-800
      success - bg-success-600 
      */}
    </div>
  );
};

export default Input;
